<template>
    <div class="user-info-block" :class="{ mobile: !showSignOutBtn }">
        <div class="content-block">
            <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="44" height="44" rx="22" fill="#3fab3e"/>
                <path d="M15.696 23.28H13.616V28H11.568V16.8H13.616V21.488H15.76L18.976 16.8H21.184L17.36 22.224L21.328 28H18.976L15.696 23.28ZM26.8679 23.28H24.7879V28H22.7399V16.8H24.7879V21.488H26.9319L30.1479 16.8H32.3559L28.5319 22.224L32.4999 28H30.1479L26.8679 23.28Z" fill="white"/>
            </svg>
            <div class="user-name-bonus-block">
                <div class="user-name" v-if="clientName">
                    {{ clientName }}
                </div>
                <div class="user-noname" v-else>
                    Имя не задано
                </div>
                <div class="bonuses">
                    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="8" height="8" rx="4" fill="#DA251C"/>
                    </svg>
                    <span class="mx-1">{{ bonusCount }}</span> Бонусов
                </div>
            </div>
        </div>
        <div class="sign-out-block" @click="signOut">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.25 23.625C12.25 23.8571 12.1578 24.0796 11.9937 24.2437C11.8296 24.4078 11.6071 24.5 11.375 24.5H5.25C4.78587 24.5 4.34075 24.3156 4.01256 23.9874C3.68437 23.6592 3.5 23.2141 3.5 22.75V5.25C3.5 4.78587 3.68437 4.34075 4.01256 4.01256C4.34075 3.68437 4.78587 3.5 5.25 3.5H11.375C11.6071 3.5 11.8296 3.59219 11.9937 3.75628C12.1578 3.92038 12.25 4.14294 12.25 4.375C12.25 4.60706 12.1578 4.82962 11.9937 4.99372C11.8296 5.15781 11.6071 5.25 11.375 5.25H5.25V22.75H11.375C11.6071 22.75 11.8296 22.8422 11.9937 23.0063C12.1578 23.1704 12.25 23.3929 12.25 23.625ZM24.2441 13.3809L19.8691 9.00594C19.7467 8.88343 19.5907 8.79998 19.4209 8.76616C19.2511 8.73234 19.075 8.74967 18.9151 8.81596C18.7551 8.88224 18.6184 8.9945 18.5222 9.13852C18.4261 9.28254 18.3749 9.45184 18.375 9.625V13.125H11.375C11.1429 13.125 10.9204 13.2172 10.7563 13.3813C10.5922 13.5454 10.5 13.7679 10.5 14C10.5 14.2321 10.5922 14.4546 10.7563 14.6187C10.9204 14.7828 11.1429 14.875 11.375 14.875H18.375V18.375C18.3749 18.5482 18.4261 18.7175 18.5222 18.8615C18.6184 19.0055 18.7551 19.1178 18.9151 19.184C19.075 19.2503 19.2511 19.2677 19.4209 19.2338C19.5907 19.2 19.7467 19.1166 19.8691 18.9941L24.2441 14.6191C24.3254 14.5378 24.39 14.4413 24.434 14.3351C24.478 14.2288 24.5007 14.115 24.5007 14C24.5007 13.885 24.478 13.7712 24.434 13.6649C24.39 13.5587 24.3254 13.4622 24.2441 13.3809Z" fill="#4D5056"/>
            </svg>
        </div>
        <!-- <div class="sign-out-block" @click="signOut" v-if="showSignOutBtn">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.25 23.625C12.25 23.8571 12.1578 24.0796 11.9937 24.2437C11.8296 24.4078 11.6071 24.5 11.375 24.5H5.25C4.78587 24.5 4.34075 24.3156 4.01256 23.9874C3.68437 23.6592 3.5 23.2141 3.5 22.75V5.25C3.5 4.78587 3.68437 4.34075 4.01256 4.01256C4.34075 3.68437 4.78587 3.5 5.25 3.5H11.375C11.6071 3.5 11.8296 3.59219 11.9937 3.75628C12.1578 3.92038 12.25 4.14294 12.25 4.375C12.25 4.60706 12.1578 4.82962 11.9937 4.99372C11.8296 5.15781 11.6071 5.25 11.375 5.25H5.25V22.75H11.375C11.6071 22.75 11.8296 22.8422 11.9937 23.0063C12.1578 23.1704 12.25 23.3929 12.25 23.625ZM24.2441 13.3809L19.8691 9.00594C19.7467 8.88343 19.5907 8.79998 19.4209 8.76616C19.2511 8.73234 19.075 8.74967 18.9151 8.81596C18.7551 8.88224 18.6184 8.9945 18.5222 9.13852C18.4261 9.28254 18.3749 9.45184 18.375 9.625V13.125H11.375C11.1429 13.125 10.9204 13.2172 10.7563 13.3813C10.5922 13.5454 10.5 13.7679 10.5 14C10.5 14.2321 10.5922 14.4546 10.7563 14.6187C10.9204 14.7828 11.1429 14.875 11.375 14.875H18.375V18.375C18.3749 18.5482 18.4261 18.7175 18.5222 18.8615C18.6184 19.0055 18.7551 19.1178 18.9151 19.184C19.075 19.2503 19.2511 19.2677 19.4209 19.2338C19.5907 19.2 19.7467 19.1166 19.8691 18.9941L24.2441 14.6191C24.3254 14.5378 24.39 14.4413 24.434 14.3351C24.478 14.2288 24.5007 14.115 24.5007 14C24.5007 13.885 24.478 13.7712 24.434 13.6649C24.39 13.5587 24.3254 13.4622 24.2441 13.3809Z" fill="#4D5056"/>
            </svg>
        </div>
        <div class="sign-out-block" @click="toProfile" v-else>
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M27.7081 16.7075L17.7081 26.7075C17.6151 26.8004 17.5048 26.8741 17.3835 26.9244C17.2621 26.9747 17.132 27.0006 17.0006 27.0006C16.8692 27.0006 16.7391 26.9747 16.6177 26.9244C16.4963 26.8741 16.386 26.8004 16.2931 26.7075C16.2001 26.6146 16.1264 26.5043 16.0762 26.3829C16.0259 26.2615 16 26.1314 16 26C16 25.8686 16.0259 25.7385 16.0762 25.6171C16.1264 25.4957 16.2001 25.3854 16.2931 25.2925L25.5868 16L16.2931 6.70751C16.1054 6.51987 16 6.26537 16 6.00001C16 5.73464 16.1054 5.48015 16.2931 5.29251C16.4807 5.10487 16.7352 4.99945 17.0006 4.99945C17.2659 4.99945 17.5204 5.10487 17.7081 5.29251L27.7081 15.2925C27.801 15.3854 27.8748 15.4957 27.9251 15.6171C27.9754 15.7385 28.0013 15.8686 28.0013 16C28.0013 16.1314 27.9754 16.2615 27.9251 16.3829C27.8748 16.5043 27.801 16.6146 27.7081 16.7075Z" fill="#DA251C"/>
            </svg>

        </div> -->
        <v-dialog v-model="showSignOutDialog" width="490">
            <v-card class="delete-dialog pl-10 pr-5 pb-10 pt-3">
                <div class="d-flex justify-end">
                    <v-btn
                        icon
                        small
                        @click="showSignOutDialog = false"
                    >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.75 5.25L5.25 18.75" stroke="#36393B" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M18.75 18.75L5.25 5.25" stroke="#36393B" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>

                    </v-btn>
                </div>
                <div>
                    <div class="header">Выйти из аккаунта?</div>
                </div>
                <div class="pt-2">
                    Вы собираетесь выйти из аккаунта на этом устройстве
                </div>

                <div class="pt-2 pr-5 d-flex align-center justify-space-between">
                    <div class="step-action">
                        <v-btn
                            @click="signOutHandler"
                            elevation="0"
                        >
                            Выйти из аккаунта
                        </v-btn>
                    </div>
                    <div class="step-action cancel">
                        <v-btn
                            @click="showSignOutDialog = false"
                            elevation="0"
                        >
                            Отмена
                        </v-btn>
                    </div>
                </div>
            </v-card>
        </v-dialog>
        <v-bottom-sheet v-model="showSignOutDialogMobile">
            <v-card class="delete-dialog pl-4 pr-2 pb-4 pt-2">
                <div class="d-flex justify-end">
                    <v-btn
                        icon
                        small
                        @click="showSignOutDialogMobile = false"
                    >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.75 5.25L5.25 18.75" stroke="#36393B" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M18.75 18.75L5.25 5.25" stroke="#36393B" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>

                    </v-btn>
                </div>
                <div>
                    <div class="header">Выйти из аккаунта?</div>
                </div>
                <div class="pt-2">
                    Вы собираетесь выйти из аккаунта на этом устройстве
                </div>

                <div class="pt-2 pr-2">
                    <div class="step-action">
                        <v-btn
                            @click="signOutHandler"
                            elevation="0"
                        >
                            Выйти из аккаунта
                        </v-btn>
                    </div>
                    <div class="step-action cancel pt-2">
                        <v-btn
                            @click="showSignOutDialogMobile = false"
                            elevation="0"
                        >
                            Отмена
                        </v-btn>
                    </div>
                </div>
            </v-card>
        </v-bottom-sheet>
    </div>
</template>

<script>
    export default {
        name: 'UserInfoBlock',

        props: {
            showSignOutBtn: Boolean,
        },

        data() {
            return {
                showSignOutDialog: false,
                showSignOutDialogMobile: false,
            }
        },

        computed: {
            bonusCount() {
                return this.$store.state.client.client?.bonuses || 0
            },
            clientName() {
                return this.$store.state.client.client?.fullName
            },
            isMobile() {
                return this.$vuetify.breakpoint.smAndDown
            },
        },

        methods: {
            async signOutHandler() {
                await this.$store.dispatch('auth/signOut')
            },
            toProfile() {
                console.log('Отправить пользователя в профиль?') // eslint-disable-line no-console
            },
            signOut() {
                if (this.isMobile) {
                    this.showSignOutDialogMobile = true
                } else {
                    this.showSignOutDialog = true
                }
            },
        },
    }
</script>

<style>
    .user-info-block {
        width: 227px;
        display: flex;
        padding: 20px 0px;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
    }
    .user-info-block.mobile{
        display: flex;
        width: 100%;
        padding: 16px 0px;
        justify-content: space-between;
        align-items: center;
    }
    .user-info-block .content-block {
        display: flex;
        align-items: center;
    }
    .user-name-bonus-block {
        height: 44px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 2px;
        margin-left: 16px;
    }
    .user-name-bonus-block .user-name {
        color: #36393B;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 140%;
        white-space: nowrap;
    }
    .user-name-bonus-block .user-noname {
        color: #36393B;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 140%;
        opacity: 0.5;
        white-space: nowrap;
    }
    .user-name-bonus-block .bonuses{
        display: flex;
        align-items: center;
    }
    .user-info-block .sign-out-block {
        cursor: pointer;
    }
    .user-name-bonus-block .user-name {
        width: 121px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>

<style>
    .delete-dialog {
        border-radius: 10px !important;
    }
    .delete-dialog .header {
        font-size: 22px;
        font-weight: bold;
    }
    .mobile .delete-dialog .header {
        font-size: 20px;
    }
    .delete-dialog .inform {
        border-radius: 10px;
        border: 1px solid #F3F4F4;
        padding: 16px;
        display: flex;
        gap: 12px;
        font-size: 14px;
    }
    .mobile .delete-dialog .inform {
        font-size: 14px;
    }
    .step-action {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .step-action .v-btn {
        display: flex;
        padding: 16px 40px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        border-radius: 10px;
        border: 2px solid #DA251C !important;
        background: #DA251C !important;
        width: 253px;
        height: 52px;
        color: #FFF;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
    .mobile .step-action .v-btn {
        width: 100% !important;
    }
    .step-action .v-btn.v-btn--disabled {
        background: #F3F4F4 !important;
        border-color: #F3F4F4 !important;
        color: #36393B !important;
    }
    .step-action.cancel .v-btn {
        background-color: #F3F4F4 !important;
        color: #36393B !important;
        border: #36393B !important;
        width: 146px;
    }
</style>
